// 应用菜单
const menuData = {
  iconClass: "el-icon-s-home",
  menuName: "应用设置",
  children: [
    // {
    //   path: "/rhqy/yyManege/carAppoint",
    //   menuName: "车辆预约",
    //   privilege: "",
    //   iconClass: "el-icon-time"
    // },
    // {
    //   path: "/rhqy/yyManege/compreApp",
    //   menuName: "综合类应用",
    //   privilege: "",
    //   iconClass: "el-icon-s-grid"
    // }
  ]
};

export { menuData };
